import { AppointmentParticipantInterface } from '../../..';

export class CreateAppointmentParticipantRequestDto implements AppointmentParticipantInterface{
  appointmentId: string;
}
